import { createContext, useContext, useState } from "react";
import { TodoPriority } from "./__generated__/TodoCreateMainNewMutation.graphql";
import { ToolbarFeature } from "widgets/src/Todo/TodoToolbar/TodoToolbarItem";

type TodoCreateState = {
  title: string;
  body?: string;
  linkedProductIds: string[];
  employeeIds: string[];
  roleIds: string[];
  teamIds: string[];
  tagIds: string[];
  priority?: TodoPriority;
  expireAt?: Date;
};

const CTX = createContext<{
  state: TodoCreateState;
  setState: React.Dispatch<React.SetStateAction<TodoCreateState>>;
  openFeature: ToolbarFeature | null;
  setOpenFeature: (feature: ToolbarFeature | null) => void;
}>({
  state: {
    title: "",
    body: undefined,
    teamIds: [],
    employeeIds: [],
    roleIds: [],
    linkedProductIds: [],
    tagIds: [],
  },
  setState: () => {},
  openFeature: null,
  setOpenFeature: () => {},
});

export function TodoCreateStateProvider(props: {
  children: React.ReactNode;
  initialTeamIds?: string[];
  initialEmployeeIds?: string[];
  initialProductIds?: string[];
}) {
  const [state, setState] = useState<TodoCreateState>({
    title: "",
    body: undefined,
    teamIds: props.initialTeamIds ?? [],
    employeeIds: props.initialEmployeeIds ?? [],
    roleIds: [],
    linkedProductIds: props.initialProductIds ?? [],
    tagIds: [],
    priority: "DEFAULT",
  });
  const [openFeature, setOpenFeature] = useState<ToolbarFeature | null>(null);

  return (
    <CTX.Provider value={{ state, setState, openFeature, setOpenFeature }}>
      {props.children}
    </CTX.Provider>
  );
}
export function useTodoCreateState() {
  const ctx = useContext(CTX);
  if (!ctx) {
    throw new Error(
      "useTodoCreateState must be used within a TodoCreateStateProvider"
    );
  }
  return ctx;
}
